<p class="text-xl mb-2">{{title}}</p>
<hr
  class="bg-green"
  [ngStyle]="{
    width: '100%',
    'min-width': dataSource.length > 0 ? '710px' : '430px',
    height: '3px',
    border: 'none'
  }"
  />
<app-load-spinner-wrapper [loading]="loading">
  <div class="w-full min-w-0 max-w-full max-h-[60dvh] overflow-x-auto overflow-y-auto touch-auto">
    <table
      mat-table
      matSort
      matSortActive="requestDate"
      matSortDirection="asc"
      matSortDisableClear
      [dataSource]="tableDataSource">
    <ng-container matColumnDef="accountType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'user type' | upperCase}} </th>
      <td mat-cell *matCellDef="let request"> {{request.accountTypeId ?? -1 | accountTypeName}} </td>
    </ng-container>
    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'user name' | upperCase}} </th>
      <td mat-cell *matCellDef="let request">
        <span
          tabindex="0"
          role="button"
          class="cursor-pointer"
          (click)="onRequestClick(request)"
          (keydown.enter)="onRequestClick(request)"
          (keydown.space)="onRequestClick(request)">
          {{request.userName}}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'email' | upperCase}} </th>
      <td mat-cell *matCellDef="let request"> {{request.email}} </td>
    </ng-container>
    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'company/clinic' | upperCase}} </th>
      <td mat-cell *matCellDef="let request"> {{request.company}} </td>
    </ng-container>
    <ng-container matColumnDef="requestDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'request date' | upperCase }} </th>
      <td mat-cell *matCellDef="let request"> {{request.requestDate | dateFormat:'MM/DD/YYYY'}} </td>
    </ng-container>
    <ng-container matColumnDef="requestType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'request type' | upperCase }} </th>
      <td mat-cell *matCellDef="let request"> {{request.requestType | portalRequestType }} </td>
    </ng-container>
    <tr class="sticky top-0 z-10 bg-white" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  @if (dataSource.length === 0) {
    <div
      class="w-full text-center my-10"
      >
      <p class="text-sm">There are no pending portal access requests at this time.</p>
    </div>
  }
</app-load-spinner-wrapper>
